import classNames from 'classnames'
import { forwardRef, type HTMLAttributes } from 'react'
import * as styles from './styles'

export type BodyProps = HTMLAttributes<HTMLDivElement>
export const Body = forwardRef<HTMLDivElement, BodyProps>(
  ({ children, className, ...props }, ref) => (
    <div
      ref={ref}
      className={classNames(styles.classes.body, className)}
      css={styles.modalBody}
      {...props}
    >
      {children}
    </div>
  )
)
Body.displayName = 'Lapidary: Body ← Modal'
